import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import moment from 'moment';

const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();
  
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};

export const fetchOxyzoLpr = createAsyncThunk(
  'due/fetchOxyzoLpr',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}oxyzo/loan-portfolio/data/${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const fetchFilteredOxyzoLpr = createAsyncThunk(
  'due/fetchFilteredOxyzoLpr',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}oxyzo/loan-portfolio/data/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

const oxyzoLoanPortfolioSlice = createSlice({
  name: 'oxyzoLoanPortfolio',
  initialState: {
    data: [],
    loading: false,
    error: null,
    totalCount: 0,

    filteredData: [],
    filteredLoading: false,
    filteredError: null,
    filteredTotalCount: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOxyzoLpr.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOxyzoLpr.fulfilled, (state, action) => {
        state.loading = false;
        // Fix: Access the correct property from API response
        state.data = action.payload.loan_portfolio_data || []; 
        state.totalCount = action.payload.total_loan_portfolio_count || 0; 
        console.log("state.data--", state.data);
      })
      .addCase(fetchOxyzoLpr.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilteredOxyzoLpr.pending, (state) => {
        state.filteredLoading = true;
        state.filteredError = null;
      })
      .addCase(fetchFilteredOxyzoLpr.fulfilled, (state, action) => {
        state.filteredLoading = false;
        // Fix: Access the correct property from API response
        state.filteredData = action.payload.loan_portfolio_data || [];
        state.filteredTotalCount = action.payload.total_loan_portfolio_count || 0; 
      })
      .addCase(fetchFilteredOxyzoLpr.rejected, (state, action) => {
        state.filteredLoading = false;
        state.filteredError = action.error.message;
      });
  }
});

export default oxyzoLoanPortfolioSlice.reducer;